import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import RentalPage from './pages/RentalPage';
import OpenBoxPage from './pages/OpenBoxPage';
import FactoryReturnedPage from './pages/FactoryReturnedPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CustomerLoginPage from './pages/CustomerLoginPage';
import ShippingDeliveryPolicyPage from './pages/ShippingDeliveryPolicyPage';
import CancellationRefundPolicyPage from './pages/CancellationRefundPolicyPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import DeploymentInfo from './components/DeploymentInfo';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:category" element={<ProductsPage />} />
              <Route path="/products/:category/:subcategory" element={<ProductsPage />} />
              <Route path="/product/:id" element={<ProductDetailPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
              <Route path="/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
              <Route path="/my-orders" element={<OrderHistoryPage />} />
              <Route path="/rental" element={<RentalPage />} />
              <Route path="/open-box" element={<OpenBoxPage />} />
              <Route path="/factory-returned" element={<FactoryReturnedPage />} />
              <Route path="/services" element={<RentalPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/login" element={<CustomerLoginPage />} />
              <Route path="/shipping-delivery-policy" element={<ShippingDeliveryPolicyPage />} />
              <Route path="/cancellation-refund-policy" element={<CancellationRefundPolicyPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-conditions" element={<TermsConditionsPage />} />
            </Routes>
            <DeploymentInfo />
          </Layout>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;